<section>
    <div *ngIf="isInUse else notInUse" class="badge">
        <xm-media-image [imageOptions]="inUseIcon" class="badge-icon" center="auto" size="auto">
        </xm-media-image>
        <span class="badge-text">{{ cbmLabelContent.inUseLabel }}</span>
    </div>
    <ng-template #notInUse>
        <div class="badge">
            <span class="not-inuse-badge-text">{{ cbmLabelContent.notInUseLabel }}</span>
        </div>
    </ng-template>
</section>
